// eslint-disable-next-line no-unused-vars
import config from '@config';
;
import '@styles/frontend';
import '@images/favicon.ico';
import './spritesvg';

import { generalInit } from './components/general';
import { menuInit } from './components/menu';

// Your code goes here ...
(function() {

  // GENERAL
  generalInit()

  // MENU
  menuInit()

})();
